export const downloadBinaryData = (content: BlobPart, mimeType: string, filename: string): void => {
  const a = window.document.createElement('a');
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  a.setAttribute('href', url);
  a.setAttribute('download', filename);
  a.click();
};
